import { loadable } from 'utils';

export const Documents = loadable(() => import('./Documents'), {});
export const Signers = loadable(() => import('./Signers'), {});
